/** Giống nhau */
/**
 * @link https://shopify.github.io/liquid/filters/abs/
 */
export const abs = (liquid: string) => liquid;
